export default {
    buttons: {
        back: 'หน้าก่อนหน้า',
        home: 'ไปหน้าหลัก',
    },
};
